import routes from '@/modules/offer/offer-routes';
import store from '@/modules/offer/offer-store';
// import OfferAutocompleteInput from '@/modules/offer/components/offer-autocomplete-input';

export default {
  // components: [OfferAutocompleteInput],
  routes,
  store,
};
